import { useTranslation } from "../../../../../hooks/useTranslation";
import { useMemo } from "react";

import { AddRestrictionButton } from "../../../components/AddRestrictionButton";
import { GridColDef } from "@mui/x-data-grid";
import { useGetLocale } from "@refinedev/core";
import {
  getFilters,
  getStandartColumns,
} from "../../../components/standartListData";
import { PaginatedList } from "../../../../../components/form/PaginatedList/PaginatedList";

type RestrictedBrand = {
  id: string;
  brandName: string;
  trademark: boolean;
  restrictionReason: string;
  infringementType: string;
  note: string;
  created: string;
};

export const RestrictedBrands = () => {
  const { translate } = useTranslation(
    "pages.storeSecurity.restrictions.restrictedBrands",
  );

  const locale = useGetLocale();
  const currentLocale = locale();

  const filters = useMemo(() => getFilters(translate), [translate]);

  const columns = useMemo<GridColDef<RestrictedBrand>[]>(
    () => [
      {
        field: "brandName",
        headerName: translate("list.fields.brandName"),
        flex: 1,
        minWidth: 150,
      },
      {
        field: "trademark",
        sortable: false,
        headerName: translate("list.fields.trademark"),
        width: 150,
      },
      ...getStandartColumns(translate, currentLocale),
    ],
    [currentLocale],
  );

  return (
    <PaginatedList
      addButton={
        <AddRestrictionButton
          translationPrefix="pages.storeSecurity.restrictions.restrictedBrands.addDialog"
          endpoint="store/restrictions/brand"
          hasDescription
        />
      }
      getUrl={(countryId) => `store/${countryId}/restrictions/brand`}
      filters={filters}
      defaultFilters={{
        search: "",
        restrictionReason: "",
        infringementType: "",
      }}
      columns={columns}
      searchLabel={translate("list.filters.search")}
    />
  );
};
